import {
  FaLaptopCode,
  FaMobileAlt,
  FaGlobe,
  FaNetworkWired,
  FaCommentsDollar,
  FaBullhorn,
  FaSearch,
  FaUsers,
  FaDesktop,
  FaRobot,
} from "react-icons/fa";

export const SERVICES = [
  {
    name: "Build Websites",
    path: "/buildwebsite",
    description:
      "Get beautifully crafted websites for your brand — fast, responsive, and built to convert.",
    icon: FaLaptopCode,
    color: "#FF6F20", // Orvitrix orange
  },
  {
    name: "Mobile Apps",
    path: "/mobileapps",
    description:
      "Launch Android and iOS apps that deliver seamless performance and delightful user experience.",
    icon: FaMobileAlt,
    color: "#008BFF", // Vibrant blue
  },
  {
    name: "Web Applications",
    path: "/webapps",
    description:
      "Develop powerful web apps — from dashboards to SaaS — with scalability at the core.",
    icon: FaGlobe,
    color: "#FFB400", // Warm yellow
  },
  {
    name: "API Gateways",
    path: "/apigateways",
    description:
      "Connect your digital services with robust, secure, and well-documented API gateways.",
    icon: FaNetworkWired,
    color: "#00C2CB", // Aqua teal
  },
  {
    name: "Consultation Services",
    path: "/consultations",
    description:
      "Need direction? Get expert tech consultation to define, refine, or pivot your digital strategy.",
    icon: FaCommentsDollar,
    color: "#D9534F", // Strong red
  },
  {
    name: "Ad Creatives",
    path: "/adcreatives",
    description:
      "Drive clicks with scroll-stopping ad creatives for Meta, Google, YouTube, and beyond.",
    icon: FaBullhorn,
    color: "#F0AD4E", // Amber
  },
  {
    name: "Web Scrapers",
    path: "/webscrapers",
    description:
      "Automate data collection from websites with custom-built, efficient, and scalable web scrapers.",
    icon: FaSearch,
    color: "#5BC0DE", // Light blue
  },
  {
    name: "CRM Platforms",
    path: "/crmplatforms",
    description:
      "Build custom CRM systems that keep your leads, customers, and deals organized and actionable.",
    icon: FaUsers,
    color: "#9B59B6", // Purple
  },
  {
    name: "Desktop Applications",
    path: "/desktopapps",
    description:
      "Create native desktop apps for Windows, macOS, and Linux with rich functionality and offline capabilities.",
    icon: FaDesktop,
    color: "#17A2B8", // Teal cyan
  },
  {
    name: "AI Agents",
    path: "/aiagents",
    description:
      "Build intelligent AI agents to automate tasks, assist users, and optimize your business operations.",
    icon: FaRobot,
    color: "#E83E8C", // Magenta
  },
];
